/*export const environment = {
	production: true,
	firebase: {
    apiKey: "AIzaSyBuGfn9MOnATI6EYsrRVPur7SYXjkd8kIw",
    authDomain: "blindvalet-production.firebaseapp.com",
    databaseURL: "https://blindvalet-production.firebaseio.com",
    projectId: "blindvalet-production",
    storageBucket: "blindvalet-production.appspot.com",
    messagingSenderId: "1072288907109"
	},
	server: "blindvalet.com",
	stripeClientKey: "pk_live_d3e2YweGFahflUaceunu2ZIn"
};*/

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyBuGfn9MOnATI6EYsrRVPur7SYXjkd8kIw",
    //authDomain: "blindvalet-production.firebaseapp.com",
    authDomain: "app.blindvalet.com",
    databaseURL: "https://blindvalet-production.firebaseio.com",
    projectId: "blindvalet-production",
    storageBucket: "blindvalet-production.appspot.com",
    messagingSenderId: "1072288907109",
    appId: "1:1072288907109:web:f57d2f74078423a212eb8c",
  },
  server: "app.blindvalet.com",
  externalHomeUrl: "https://blindvalet.com",
  // Empty = preview opens the public https://<slug>.<sitesBaseDomain> address.
  sitesPreviewBase: "",
  // Hosted club sites live under this domain: <slug>.blindvalet.site.
  sitesBaseDomain: "blindvalet.site",
  stripeClientKey: "pk_live_d3e2YweGFahflUaceunu2ZIn",
  // Effective date of the published Terms and Conditions / Privacy Policy.
  // Bumping this triggers the in-app acceptance interstitial for any user
  // whose profile.tcAcceptedVersion is missing or older.
  tcVersion: "2026-05-04",
  // Firebase App Check (Realtime Database is enforced): the "app" web app +
  // the production reCAPTCHA Enterprise key (domains blindvalet.com,
  // blindvalet.site, blackcatevents.fr). See src/app-check.ts.
  appCheck: {
    siteKey: "6Lc2X-UtAAAAANUt5cBwlfzb_MTi4YHFf0M2jmgg",
    debug: false,
  },
  // Monotonic build version for the force-refresh gate. When
  // /config/minClientVersion in Firebase exceeds this, stale clients auto-reload
  // to pick up the latest build. Bump on each gated release; always deploy the
  // build BEFORE raising /config/minClientVersion (never set it above appVersion).
  appVersion: 15,
  // Feature flag for the per-table break button (tombstone creation). Stays
  // false until every connected client understands `broke` tombstones — see the
  // two-phase rollout in the plan.
  enablePerTableBreak: true,
};
